import PageHeader from "@/components/PageHeader";
import TabNavigation from "@/components/tabs/TabNavigation";
import Field from "@/components/fields/Field";
import { Artwork } from "@/components/ArtworkSlot";
import buildTrackTabs from "../trackTabs";

interface RightsHolder {
  name: string;
  split_percentage: number;
  pro_affiliation: string | null;
  ipi_cae_number: string | null;
}

interface MasterOwner {
  name: string;
  split_percentage: number;
}

interface RightsShowProps {
  track: {
    id: number;
    title: string;
    artwork_attached: boolean;
    rights_locked: boolean;
  };
  artwork: Artwork;
  writers: RightsHolder[];
  master_owners: MasterOwner[];
}

const RIGHTS_LOCKED_MESSAGE =
  "A contract has been issued for this track, so rights can no longer be edited.";

const Show: React.FC<RightsShowProps> = ({ track, artwork, writers, master_owners }) => {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-5 md:gap-10">
      <PageHeader
        backLink={{ href: "/tracks", text: "Back to all tracks" }}
        title={track.title}
        primaryAction={{
          href: `/tracks/${track.id}/rights/edit`,
          text: "Edit",
          disabled: track.rights_locked,
          tooltip: track.rights_locked ? RIGHTS_LOCKED_MESSAGE : undefined,
        }}
        artwork={{
          trackId: track.id,
          uploaded: track.artwork_attached,
          thumbnailUrl: artwork.thumbnail_url,
          originalUrl: artwork.original_url,
          alt: `${track.title} artwork`,
        }}
      />
      <TabNavigation
        tabs={buildTrackTabs(track.id, "rights")}
      />
      <div className="dark:bg-cream-950 flex w-full flex-col gap-6 rounded-2xl bg-white p-6 shadow md:p-10">
        <h2 className="text-cream-900 dark:text-cream-100 text-lg font-semibold">
          Master Owners
        </h2>
        {master_owners.length === 0 ? (
          <p className="text-cream-600 dark:text-cream-400 text-sm">
            No master owners have been added yet.
          </p>
        ) : (
          master_owners.map((owner) => (
            <div
              key={owner.name}
              className="border-cream-200 dark:border-cream-800 flex flex-col gap-4 border-b pb-6 last:border-b-0 last:pb-0"
            >
              <Field label="Name" value={owner.name} />
              <Field
                label="Split"
                value={`${owner.split_percentage}%`}
              />
            </div>
          ))
        )}
      </div>
      <div className="dark:bg-cream-950 flex w-full flex-col gap-6 rounded-2xl bg-white p-6 shadow md:p-10">
        <h2 className="text-cream-900 dark:text-cream-100 text-lg font-semibold">
          Writers
        </h2>
        {writers.length === 0 ? (
          <p className="text-cream-600 dark:text-cream-400 text-sm">
            No writers have been added yet.
          </p>
        ) : (
          writers.map((writer) => (
            <div
              key={writer.name}
              className="border-cream-200 dark:border-cream-800 flex flex-col gap-4 border-b pb-6 last:border-b-0 last:pb-0"
            >
              <Field label="Name" value={writer.name} />
              <Field
                label="Split"
                value={`${writer.split_percentage}%`}
              />
              <Field label="PRO Affiliation" value={writer.pro_affiliation} />
              <Field label="IPI/CAE Number" value={writer.ipi_cae_number} />
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Show;
